import { RoutesStorageInterface } from "./interfaces";

export const getRoutesData = (): RoutesStorageInterface =>
  JSON.parse(localStorage.getItem("routes")) || {};

export const saveRoutesData = (data: RoutesStorageInterface | {}): void =>
  localStorage.setItem("routes", JSON.stringify(data));
